/*
 * Copyright © 2017, Rezo Zero
 *
 * This file is part of Jérôme Poulalier.
 *
 * Jérôme Poulalier can not be copied and/or distributed without
 * the express permission of Rezo Zero.
 *
 * @file Utils.js
 * @author Adrien Scholaert <adrien@rezo-zero.com>
 * @copyright Rezo Zero 2018
 */

const mobileOrNot = (/Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent))

export function rgb2hex (rgb) {
    rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i)
    return (rgb && rgb.length === 4) ? '#' +
        ('0' + parseInt(rgb[1], 10).toString(16)).slice(-2) +
        ('0' + parseInt(rgb[2], 10).toString(16)).slice(-2) +
        ('0' + parseInt(rgb[3], 10).toString(16)).slice(-2) : ''
}

export function braiffily (el) {
    const $el = $(el)
    let text = $el.text()
    let letters = text.split('')
    let html = ''

    for (let i in letters) {
        html += '<span class="braille-wrap"><span class="regular">' + letters[i] + '</span><span class="braille">' + letters[i] + '</span></span>'
    }

    $el.html(html)
}

export function isMobile () {
    return mobileOrNot
}



// WEBPACK FOOTER //
// ./webpack/js/utils/Utils.js